import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./formula-payable-scheme.actions";
import {map, switchMap} from "rxjs/operators";
import * as fromGraphql from "./formula-payable-scheme.graphql";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";


@Injectable()
export class FormulaPayableSchemeEffects {

  createServiceFormulaPayableScheme$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createFormulaPayableSchemes),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_FORMULA_PAYABLE_ITEM,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertFormulaPayableScheme({ formulaPayableScheme: result?.data }));
              await this.notificationService.successMessage('Created Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });


  updateServicePercentageScheme$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.editFormulaPayableSchemes),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_FORMULA_PAYABLE_ITEM,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(async ({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertFormulaPayableScheme({ formulaPayableScheme: result?.data }));
              await this.notificationService.successMessage('Updated Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  deleteServicePercentageScheme$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeFormulaPayableSchemes),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_FORMULA_PAYABLE_ITEM,
        variables: {
          itemUniqueId: action?.itemUniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(async ({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteFormulaPayableScheme({ id: action.id }));
              await this.notificationService.successMessage('Deleted Successfully');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getServiceFormulaPayableSchemes$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getFormulaPayableSchemes),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_FORMULA_PAYABLE_ITEM,
        fetchPolicy: 'network-only',
        variables: {
          formularUniqueId: action.formularUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching formula based payable items'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadFormulaPayableSchemes({ formulaPayableSchemes: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  citizenGetInstitutionServiceFormulaPayableItems$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetInstitutionServiceFormulaPayableItems),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.CITIZEN_GET_INSTITUTION_SERVICE_FORMULAR_PAYABLE_ITEM,
        fetchPolicy: 'network-only',
        variables: {
          formularUniqueId: action.formularUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching formula based payable items'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadFormulaPayableSchemes({ formulaPayableSchemes: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
